import { mergeDeepLeft, pathOr, prop } from "ramda";
import {GET_FILTER_LIST_SUCCESS} from "./actions/get-filter-list";

export const initialState = {
  entities: {},
  ids: [],
};

const entities = (state = initialState.entities, action) => {
  switch (action.type) {
    case GET_FILTER_LIST_SUCCESS: {
      return mergeDeepLeft(
        pathOr({}, ["payload", "entities", "filters"], action),
        state
      );
    }

    default:
      return state;
  }
};

const ids = (state = initialState.ids, action) => {
  switch (action.type) {
    case GET_FILTER_LIST_SUCCESS: {
      return pathOr([], ["payload", "result"], action);
    }

    default:
      return state;
  }
};

export default (state, action) => {
  return {
    entities: entities(prop("entities", state), action),
    ids: ids(prop("ids", state), action),
  };
};
